import {Component, OnInit, OnDestroy, Renderer2} from '@angular/core';
import {Router, NavigationStart, NavigationCancel, NavigationEnd} from '@angular/router';
import {Location, LocationStrategy, PathLocationStrategy} from '@angular/common';
import {filter} from 'rxjs/operators';

declare let $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent implements OnInit, OnDestroy {
    location: any;
    routerSubscription: any;
    constructor(private router: Router,
                private renderer: Renderer2) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.location = event.urlAfterRedirects;
            }
        });
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
        const isWindowsOrLinux =
            navigator.userAgent.includes('Windows') || navigator.userAgent.includes('Macintosh');

        if (isWindowsOrLinux) {
            const mainContainer = document.getElementById('main-content');
            if (mainContainer) {
                this.renderer.setStyle(mainContainer, 'zoom', '0.8');
                this.renderer.setStyle(mainContainer, 'width', '100%');
                this.renderer.setStyle(mainContainer, 'margin', '0 auto');
                this.renderer.setStyle(document.body, 'overflowX', 'hidden');
            }
        }
    }


    ngOnDestroy() {
        this.routerSubscription.unsubscribe();
    }
}
